import { createSlice } from '@reduxjs/toolkit'

import { removeDowngradeAction } from 'features/billing/actions/remove_scheduled_downgrade'

const slice = createSlice({
  name: 'promptToRemoveScheduledDowngrade',
  initialState: {
    step: 'prompt',
    loading: false,
    error: null
  },
  reducers: {
    reset: (state) => {
      state.step = 'prompt'
      state.loading = false
      state.error = null
    }
  },
  extraReducers: (builder) => {
    builder.addCase(removeDowngradeAction.pending, (state) => {
      state.loading = true
    })
    builder.addCase(removeDowngradeAction.fulfilled, (state) => {
      state.loading = false
      state.step = 'success'
    })
    builder.addCase(removeDowngradeAction.rejected, (state, { payload }) => {
      state.loading = false
      state.step = 'failure'
      state.error = payload
    })
  }
})

export const { reducer, actions: { reset } } = slice
